"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_FREE_WEEKLY_BUDDY_SESSION_COUNT = void 0;
// how many weekly buddy sessions a free user can have
exports.MAX_FREE_WEEKLY_BUDDY_SESSION_COUNT = 5;
